import { Lock } from 'lucide-react';
import { EmptyState } from '@/components/common/EmptyState';

export function FeatureDisabledPlaceholder() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6">
      <EmptyState
        icon={<Lock className="size-10" />}
        title="Feature disabled"
        description="This module isn't available for your tenant. Contact your administrator to request access."
      />
    </div>
  );
}
